var _excluded = ["title", "subtitle", "message", "warning", "externalLink", "externalLinkText", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaExternalLinkAlt } from 'react-icons/fa';
import { Box, Flex, HStack, Link, LinkButton, VStack } from '../../../components';
import { omitThemingProps, tqc, useStyleConfig } from '../../../system';
import { useLocale } from '../../utils';
import { IconCheckCircle as SuccessIconWales } from '../icons/wales/IconCheckCircle';
import { __DEV__ } from '../../../utils';
var testIds = {
  container: 'success-banner',
  title: 'success-banner__title',
  subtitle: 'success-banner__subtitle',
  message: 'success-banner__message',
  warning: 'success-banner__warning',
  icon: 'success-banner__icon',
  externalLink: 'success-banner__externalLink'
};
var WarningIcon = tqc(FaExclamationTriangle);
var SuccessIcon = tqc(FaCheckCircle);
var ExternalLinkIcon = tqc(FaExternalLinkAlt);
export var SuccessBanner = props => {
  var locale = useLocale();
  var styles = useStyleConfig('SuccessBanner', _objectSpread({}, props), {
    isMultiPart: true
  });
  var successBannerProps = omitThemingProps(props);
  var {
      title,
      subtitle,
      message,
      warning,
      externalLink,
      externalLinkText,
      children
    } = successBannerProps,
    rest = _objectWithoutProperties(successBannerProps, _excluded);
  return /*#__PURE__*/React.createElement(tqc.div, _extends({
    role: "alert",
    status: "success",
    className: "tqc-success-banner",
    "data-testid": testIds.container,
    sx: styles.alert
  }, rest), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, _extends({
    sx: styles.body,
    className: "tqc-success-banner__body"
  }, rest), /*#__PURE__*/React.createElement(VStack, {
    spacing: [4, 6]
  }, locale === 'wales' ? /*#__PURE__*/React.createElement(SuccessIconWales, {
    sx: styles.successIcon,
    "data-testid": testIds.icon
  }) : /*#__PURE__*/React.createElement(SuccessIcon, {
    sx: styles.successIcon,
    "data-testid": testIds.icon
  }), /*#__PURE__*/React.createElement(tqc.h2, {
    sx: styles.title,
    className: "tqc-success-banner__title",
    "data-testid": testIds.title
  }, title), subtitle && /*#__PURE__*/React.createElement(tqc.h3, {
    sx: styles.subtitle,
    className: "tqc-success-banner__subtitle",
    "data-testid": testIds.subtitle
  }, subtitle), message && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(tqc.p, {
    sx: styles.message,
    className: "tqc-success-banner__message",
    "data-testid": testIds.message
  }, message)), externalLink && externalLinkText && /*#__PURE__*/React.createElement(LinkButton, {
    as: Link,
    className: "tqc-success-banner__externalLink",
    target: "_blank",
    href: externalLink,
    "data-testid": testIds.externalLink
  }, /*#__PURE__*/React.createElement(HStack, {
    sx: styles.externalLink
  }, /*#__PURE__*/React.createElement(tqc.p, {
    fontWeight: "semibold"
  }, externalLinkText), /*#__PURE__*/React.createElement(ExternalLinkIcon, null))))), locale !== 'wales' && warning && /*#__PURE__*/React.createElement(Flex, {
    sx: styles.warningBody,
    className: "tqc-success-banner__warning-body",
    justify: "center",
    "data-testid": testIds.warning
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    sx: styles.warningIcon
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(tqc.p, {
    sx: styles.warning,
    className: "tqc-success-banner__warning"
  }, warning))), children && /*#__PURE__*/React.createElement(Flex, {
    sx: styles.contentBody,
    className: "tqc-success-banner__content-body",
    justify: "center"
  }, children)));
};
if (__DEV__) {
  SuccessBanner.displayName = 'SuccessBanner';
}